// src/core/services/errors.ts
export class NoWodError extends Error {
  constructor(date: string) {
    super(`Sin WOD programados: ${date}`);
    this.name = 'NoWodError';
  }
}

export class ApiError extends Error {
  constructor(status: number, message?: string) {
    super(message || `Error de servidor (código ${status})`);
    this.name = 'ApiError';
  }
}
export class FirebaseError extends Error {
  constructor(message: string) {
    super(`Firebase error: ${message}`);
    this.name = 'FirebaseError';
  }
}
export class InvalidResponseError extends Error {
  constructor(message: string) {
    super(`Respuesta inválida del servidor: ${message}`);
    this.name = 'InvalidResponseError';
  }
}
export class NetworkError extends Error {
  constructor(message: string) {
    super(`Error de red: ${message}`);
    this.name = 'NetworkError';
  }
}
export class UnauthorizedError extends Error {
  constructor() {
    super('No autorizado. Por favor, inicia sesión.');
    this.name = 'UnauthorizedError';
  }
}
export class ForbiddenError extends Error {
  constructor() {
    super('Acceso prohibido. No tienes permiso para realizar esta acción.');
    this.name = 'ForbiddenError';
  }
}
export class NotFoundError extends Error {
  constructor() {
    super('No se encontró el recurso solicitado.');
    this.name = 'NotFoundError';
  }
}
